import { lazy } from 'react';

const ProblemSolutionSection = lazy(() => import('../ProblemSolutionSection'));

const ProblemSolutionSectionLazy = () => {
  return <ProblemSolutionSection />;
};

export default ProblemSolutionSectionLazy; 